// extracted by mini-css-extract-plugin
module.exports = {"scorecard-button":"styles-module__scorecard-button___39i0R"};